<template>
	<v-card class="rounded-lg circuits-container">
		<div class="card-header">
			<v-select
				outlined
				class="rounded-lg"
				v-model="localSelectedComponent"
				:items="componentOptions"
				return-object
			>
				<template #selection="{ item }">
					<h1 class="mx-2 my-4">{{ item.text }}</h1>
				</template>
			</v-select>

			<v-spacer></v-spacer>
			<div class="sort-container">
				<div class="sort-icon">
					<v-icon @click="reverseOrder">
						mdi-sort-{{ sortIcon }}
					</v-icon>
				</div>
				<v-select
					dense
					label="Ordenar por"
					:items="[...orderBy.items]"
					v-model="orderBy.value"
					@change="fetchCircuits"
				></v-select>
			</div>
		</div>
		<div class="circuits-conditional" v-if="circuits.length > 0">
			<v-pagination
				:length="numberOfPages"
				v-model="page"
				color="accent"
				circle
			></v-pagination>
			<span class="number-of-results"
				>Mostrando {{ circuits.length }} de {{ count }} resultados</span
			>
			<div class="circuits">
				<circuit-component
					class="circuit-component"
					v-for="circuit in circuits"
					:key="circuit.id"
					:circuit="circuit"
					@inscribedInCircuit="fetchCircuits"
					@updated-circuit="fetchCircuits"
				></circuit-component>
			</div>
			<v-pagination
				:length="numberOfPages"
				v-model="page"
				color="accent"
				circle
				class="pagination-bottom"
			></v-pagination>
		</div>
		<h3 v-else>No hay circuitos activos con los filtros seleccionados</h3>
	</v-card>
</template>

<script>
//Components
import CircuitComponent from "./CircuitComponent";
import axios from "axios";

export default {
	components: {
		CircuitComponent,
	},
	props: {
		filter: Object,
		title: {
			type: String,
			default: "Circuitos",
		},
		selectedComponent: Object,
		componentOptions: Array,
	},
	data() {
		return {
			circuits: [],
			limit: 6,
			skip: 0,
			count: 0,
			page: 1,
			orderBy: {
				items: ["Fecha de creación", "Fecha de inicio", "Fecha de fin"],
				values: ["createdAt", "startDate", "finishDate"],
				value: "Fecha de creación",
			},
			sort: 1,
			sortIcon: "ascending",
			localSelectedComponent: { ...this.selectedComponent },
		};
	},
	computed: {
		numberOfPages() {
			return Math.floor((this.count - 1) / this.limit) + 1;
		},
	},
	watch: {
		page() {
			if ((this.skip = this.limit * (this.page - 1)) < 0) {
				this.skip = 0;
			}
			this.fetchCircuits(this.filter);
		},
		count() {
			while (this.count - this.skip <= 0) {
				this.skip -= this.limit;
			}
			this.page = Math.floor(this.skip / this.limit) + 1;
		},
		filter() {
			this.fetchCircuits();
		},
		localSelectedComponent() {
			this.$emit("change-component", this.localSelectedComponent);
		},
	},
	mounted() {
		this.fetchCircuits();
	},
	methods: {
		reverseOrder() {
			this.sort *= -1;
			this.sort === -1
				? (this.sortIcon = "descending")
				: (this.sortIcon = "ascending");

			this.fetchCircuits();
		},
		async fetchCircuits() {
			try {
				this.$emit("loading", true);
				const response = await axios.get("/circuits", {
					params: {
						limit: this.limit,
						page: this.page,
						orderBy: this.orderBy.values[
							this.orderBy.items.indexOf(this.orderBy.value)
						],
						sort: this.sort,
					},
				});
				this.circuits = response.data.circuits;
				this.count = response.data.count;
			} catch (error) {
				//But if it is not possible, redirect the user to the login
				if (error.response && error.response.status === 401) {
					this.$router.push({
						name: "UserLogin",
						params: {
							redirect: this.$route.fullPath,
						},
					});
				} else {
					//In case the server is not working. show an error
					this.$emit("snackbar-event", {
						color: "error",
						text:
							"Ha ocurrido un error, vuelva a intentarlo más tarde",
					});
				}
			} finally {
				this.$emit("loading", false);
			}
		},
	},
};
</script>

<style lang="scss" scoped>
@import "../../scss/_mixins.scss";

.circuits-container {
	padding: 1em;
	background-color: #f9f9f9;
	display: flex;
	flex-direction: column;
	align-items: center;

	@include desktop() {
		padding: 2em;
	}

	.card-header {
		width: 100%;
		display: flex;
		margin-bottom: 1em;
		flex-direction: column;

		@include desktop() {
			flex-direction: row;
		}

		h1 {
			margin-left: 1em;
			margin-bottom: 1em;
			flex: 5;

			@include desktop() {
				margin-bottom: 0;
				margin-left: 0;
			}
		}

		/*Sort container */
		.sort-container {
			flex: 1;
			display: flex;
			/* Sorting select */
			.v-select {
				transform: translateY(0.3em);
			}

			/*Sorting icon */
			.sort-icon {
				margin-right: 0.5em;
				font-size: 1.6em;
				transform: translateY(0.1em);
			}
		}
	}

	.circuits-conditional {
		width: 100%;
		height: 100%;
		flex: 1;
		display: flex;
		flex-direction: column;

		.circuits {
			display: flex;
			flex-wrap: wrap;
			justify-content: space-evenly;

			.number-of-results {
				margin-right: auto;
				padding-left: 1em;
			}

			.circuit-component {
				margin: 1em 2em;
				width: 100%;
			}
		}

		.pagination-bottom {
			margin-top: auto;
		}
	}
}
</style>
